var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"text-sm sm:text-base",attrs:{"aria-label":"breadcrumb"}},[_c('NuxtLink',{attrs:{"to":_vm.localePath('/')}},[_vm._v("\n    "+_vm._s(_vm.$t('Home'))+"\n  ")]),_vm._v("\n  /\n  "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }